import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getDefaultValuesForPaymentMethodForm } from "components/pages/paymentMethods/paymentMethodForm/getDefaultValuesForPaymentMethodForm";
import { getErrorMessage } from "helpers";
import { agentPaymentsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetAgentPaymentMethod = ({
	tab,
	fetchData,
	agentId,
}: {
	fetchData: { page: number; filters: any; sortBy: { [key: string]: any } };
	tab: string;
	agentId: any;
}) => {
	const dispatch = useDispatch();
	const { page, sortBy } = fetchData;
	const queryResult = useQuery(
		["getAgentPaymentMethods", tab, page, sortBy],
		() =>
			agentPaymentsService.getAgentPaymentMethods({
				page,
				sortBy,
				agentId,
			}),
		{
			select: (data: any) => {
				return {
					...data,
					items: data?.items?.map(x =>
						getDefaultValuesForPaymentMethodForm(x, "MM"),
					),
				};
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetAgentPaymentMethod;
